/**
 * TODO:  Reorganize the order of computed items, Alphabetically?  Grouped by use?
 */
import {helpers} from '@/ft-vue-core'

import {detailDefault} from '../util/defaults'
import moment from 'moment'

const {deepClone} = helpers

export default {
  computed: {
    filteredItemDetails () {
      return this.itemData.discreteCovers ? this.itemDetails : this.itemDetails.filter((d, i) => i < 1)
    },
    selectedMemberIds () {
      return this.itemData.details.filter(d => d.memberId).map(d => d.memberId)
    },
    reservationDressCode () {
      const restrictionObject = this.restrictionObject
      if (!restrictionObject.dressCodeId) return null
      return this.dressCodeMap[restrictionObject.dressCodeId]
    },
    reservationMusicalStyle () {
      const restrictionObject = this.restrictionObject
      if (!restrictionObject.musicalStyleId) return null
      return this.musicalStyleMap[restrictionObject.musicalStyleId]
    },
    reservationNoChildren () {
      const restrictionObject = this.restrictionObject
      if (restrictionObject.childrenAllowed) return null
      return 'No Children'
    },
    reservationTheme () {
      const restrictionObject = this.restrictionObject
      if (!restrictionObject.theme) return null
      return restrictionObject.theme
    },
    reservationExtras () {
      const restrictionObject = this.restrictionObject
      if (!restrictionObject.extras) return null
      return restrictionObject.extras
    },
    restrictionObject () {
      const event = this.selectedEvent
      if (this.forEvent && event) {
        return event
      }
      return {}
    },
    selectableMealPeriodDates () {
      return ((this.availableMealPeriodDates || [])[0] || {}).dates || []
    },
    blockedMealPeriodDates () {
      return ((this.availableMealPeriodDates || [])[0] || {}).blockedDates || []
    },
    partialMealPeriodDates () {
      return ((this.availableMealPeriodDates || [])[0] || {}).partialDates || []
    },
    eventMealPeriodDates () {
      return ((this.availableMealPeriodDates || [])[0] || {}).eventDates || []
    },
    showRestrictionPanel () {
      const restrictionObject = this.restrictionObject
      return restrictionObject.childrenAllowed === false || restrictionObject.musicalStyleId || restrictionObject.dressCodeId || restrictionObject.theme || restrictionObject.extras
    },
    forceReadOnly () {
      return !this.$ftAccess.manageReservations
    },
    enableNoShow () {
      return true
    },
    useNoShowSelect () {
      return !this.itemData.discreteCovers && this.itemData.details.length > 1
    },
    noShowSelectList () {
      const result = []
      for (let i = 0, l = this.itemData.details.length; i <= l; i++) {
        result.push({value: i, text: '' + i})
      }
      return result
    },
    noShowCount: {
      get () {
        const result = this.itemData.details.reduce((acc, d) => acc + (d.noShow ? 1 : 0), 0)
        console.log('noShowCount', result)
        return result
      },
      set (val) {
        console.log('Setting noShowCount', val)
        const details = this.itemData.details
        const currentCount = details.reduce((acc, d) => acc + (d.noShow ? 1 : 0), 0)
        console.log('Current count', currentCount)
        const l = details.length
        if (val === currentCount || !l) return
        const start = l - val
        for (let i = 0; i < l; i++) {
          const detail = details[i]
          detail.noShow = i < start ? detail.show === null ? null : false : true
        }
      }
    },
    hasTableAndCheckNumber () {
      return this.itemData.discreteCovers && this.partySize > 1 && this.promptForTableNumber
    },
    isDeleteHidden () {
      return true
    },
    reservationNotificationModes () {
      return [
        {text: 'Suppress Notifications', value: 'NO_SEND'},
        {text: this.isNewItem ? 'Send Notifications' : 'Send Notifications On Change', value: 'AUTO_SEND'},
        ...this.isNewItem ? [] : [{text: 'Resend Notification', value: 'RESEND'}]
      ]
    },
    isOriginalTime () {
      const o = this.originalItem
      const d = this.itemData
      // eslint-disable-next-line
      return !o || (o.locationId === d.locationId && o.eventId == d.eventId && o.date === d.date && o.time === d.time)
    },
    usedTableCount () {
      return (this.itemData.tableAssignments || []).reduce((a, t) => a + parseInt(t.quantity, 10), 0)
    },
    overSeatingTimeMessage () {
      const seating = this.selectedSeatingTime
      const results = []
      if (seating) {
        if (seating.blockReason) return seating.blockReason
        Object.values(seating.seatingCounts || {}).forEach(c => {
          let max = c.max
          let covers = c.periodCovers + this.partySize
          if (covers > max) {
            results.push(covers - max + ' over ' + c.name + ' maximum of ' + max)
          }
        })
        if (!results.length && seating.waitlistCovers) {
          results.push(seating.waitlistCovers + ' others on waitlist')
        }
        const periodCounts = this.periodCountsByPartySize(seating, this.partySize)
        if (periodCounts) {
          const usedTables = periodCounts.totalTables - periodCounts.availTables + this.usedTableCount
          if (usedTables > periodCounts.totalTables) {
            const over = usedTables - periodCounts.totalTables
            results.push(over + ' ' + (over > 1 ? 'tables' : 'table') + ' over capacity.')
          }
        }
        const restriction = this.memberRestrictionsMap[seating.memberRestrictionId]
        if (restriction) {
          results.push(restriction.name)
        }
      }
      return results.join('; ')
    },
    discreteCoversWarning () {
      return this.discreteCoversMatchSeating ? '' : 'Does not match setting for this ' + this.eventOrLocation
    },
    discreteCoversMatchSeating () {
      const seating = this.selectedSeatingTime
      return !seating || seating.discreteCovers === this.itemData.discreteCovers
    },
    numberOfChecksSelector () {
      // Get array of check number counts from 1 to party size
      return this.itemData.details.map((d, i) => ({value: i + 1}))
    },
    checkNumberSelector () {
      // Get array of check numbers from 1 to number of checks
      const max = this.itemData.numberOfChecks
      return this.numberOfChecksSelector.filter((n, i) => i < max)
    },
    hasGuests () {
      return this.itemData.details.find(d => d.guestTypeId && d.guestTypeId !== this.guestTbdId)
    },
    overPartySizeMessage () {
      return this.partySize > this.maxPartySize ? 'Over ' + this.eventOrLocation + ' maximum party size of ' + this.maxPartySize : undefined
    },
    reservationPageTitle () {
      const pageTitle = !this.isPlaceholderReservation && this.itemData.waitlist ? 'Edit Waitlist' : this.pageTitle
      return !this.showItem || !this.itemData.id ? pageTitle : pageTitle + ' #' + this.itemData.id
    },
    reservationPageBarButtons () {
      const resButtons = []
      if (this.showCreateWaitlist) {
        resButtons.push({text: 'Waitlist', mobileIcon: 'mdi-pause', action: this.convertToWaitlistAndSave, disabled: this.isSaveDisabled, hide: false, color: this.$ftStyle.pageBarWaitlistButtonColor, loading: this.isDataLoading})
      } else if (this.showConvertWaitListToReservation) {
        resButtons.push({text: 'Make Reservation', mobileIcon: 'mdi-play', action: this.convertWaitlistToReservation, disabled: this.isSaveDisabled, hide: false, color: this.$ftStyle.pageBarUnWaitlistButtonColor, loading: this.isDataLoading})
      }
      
      // Used in Floor Plan implementation. It is possible to populate fields
      // with pre-loaded itemData, in which case we want the save functionality
      // to be different than normal.
      if (!this.existingItemData) {
        return resButtons.concat(this.pageBarButtons)
      } 
      let buttons = deepClone(this.pageBarButtons)
      const saveIndex = buttons.findIndex(b => b.text === 'Save')
      if (saveIndex !== -1) {
        Object.assign(buttons[saveIndex], {
          text: 'Done',
          action: () => this.onClose?.(this.itemData)
        })
      }
      return resButtons.concat(buttons)
    },
    reservationContextMenu () {
      const menuItems = [
        {
          title: 'Save as Waitlist',
          icon: 'mdi-pause',
          action: this.convertToWaitlistAndSave,
          hide: !this.showCreateWaitlist || !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: 'Convert to Reservation',
          icon: 'mdi-play',
          action: this.convertWaitlistToReservation,
          hide: !this.showConvertWaitListToReservation || !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: 'Move to Waitlist',
          icon: 'mdi-pause',
          disabled: this.isSaveDisabled,
          action: this.convertToWaitlist,
          hide: !this.showConvertReservationToWaitList || this.isNewItem || !this.editPanelActive ||
            this.itemData.cancelled || this.isPlaceholderReservation || this.itemData.waitlist
        },
        {hide: !this.editPanelActive}, // divider
        {
          title: this.toggleDiscreteConfirmStatTitle,
          icon: 'mdi-phone',
          action: () => {this.showConfirmationDetails = !this.showConfirmationDetails},
          hide: !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: 'Add More Reservees',
          icon: 'mdi-account-multiple-plus',
          disabled: this.isSaveDisabled,
          action: this.addMultiplePrompt,
          hide: !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: this.toggleDiscreteCoversMenuTitle,
          icon: 'mdi-account-multiple-outline',
          disabled: this.isSaveDisabled,
          action: () => {this.promptDiscreteCovers()},
          hide: !this.editPanelActive || !!this.itemData.cancelled
        },
        {hide: !this.editPanelActive || this.isNewItem}, // divider,
        {
          title: 'Set as Walk-In',
          icon: 'mdi-walk',
          disabled: this.isSaveDisabled,
          action: () => {this.itemData.walkIn = true},
          hide: this.isNewItem || !this.editPanelActive || this.itemData.cancelled || this.itemData.walkIn
        },
        {
          title: 'Clear Walk-In',
          icon: 'mdi-walk',
          disabled: this.isSaveDisabled,
          action: () => {this.itemData.walkIn = false},
          hide: this.isNewItem || !this.editPanelActive || this.itemData.cancelled || !this.itemData.walkIn
        },
        {hide: !this.editPanelActive}, // divider
        {
          title: this.toggleCancelledMenuTitle,
          icon: 'mdi-account-remove',
          disabled: !this.itemData.cancelledDetails || !this.itemData.cancelledDetails[0],
          action: () => {this.toggleCancelledReservee()},
          hide: this.isNewItem || !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: 'Cancel Reservation',
          icon: 'mdi-cancel',
          disabled: this.isSaveDisabled,
          action: () => {this.cancelReservationPrompt()},
          hide: this.isNewItem || !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: 'Un-Cancel Reservation',
          icon: 'mdi-backup-restore',
          disabled: this.isSaveDisabled,
          action: () => {this.unCancelReservationPrompt()},
          hide: !this.showItem || this.isNewItem || !this.editPanelActive || !this.itemData.cancelled
        },
        {hide: !this.editPanelActive}, // divider
        {
          title: 'Mark All No-Show',
          icon: 'mdi-eye-off-outline',
          disabled: this.isSaveDisabled || this.noShowCount >= this.itemData.details.length,
          action: () => {this.markAllNoShow()},
          hide: this.isNewItem || !this.editPanelActive || !!this.itemData.cancelled
        },
        {
          title: 'Clear All No-Show',
          icon: 'mdi-eye-outline',
          disabled: this.isSaveDisabled || this.noShowCount < 1,
          action: () => {this.clearAllNoShow()},
          hide: this.isNewItem || !this.editPanelActive || !!this.itemData.cancelled
        }
      ]
      return this.defaultContextMenu.concat(menuItems)
    },
    toggleDiscreteConfirmStatTitle () {
      return (this.showConfirmationDetails ? 'Hide' : 'Show') + ' Confirmation Details'
    },
    toggleDiscreteCoversMenuTitle () {
      return (this.itemData.discreteCovers ? 'Hide' : 'Show') + ' Details for Each Reservee'
    },
    toggleCancelledMenuTitle () {
      return (this.showCancelledReservees ? 'Hide' : 'Show') + ' Canceled Reservees'
    },
    tableNumberUsageNoResults () {
      return this.isDataLoading ? 'Loading ...' : 'No table numbers in use' + (this.noTimeSelected ? '' : ' within ' + this.tableNumberUseOffset + ' minutes')
    },
    tableNumberParsed () {
      return this.splitTableNumbers(this.itemData.tableNumber)
    },
    allowShowTableNumberUse () {
      return this.seatingTimesList && this.seatingTimesList[0]
    },
    partySizeSelect () {
      if (!this.itemData.details) return 0
      const start = this.lastOpenDetail !== null ? Math.max(1, this.lastOpenDetail + 1) : this.itemData.details.length
      const end = Math.max(this.maxPartySize, this.itemData.details.length)
      const result = []
      for (let i = start; i <= end; i += 1) {
        result.push({id: i, value: i})
      }
      return result
    },
    partySize: {
      get () {
        return this.itemData.details && this.itemData.details.length
      },
      set (val) {
        if (!this.itemData.details) return
        if (val > this.itemData.details.length) {
          const newDetails = []
          for (let i = this.itemData.details.length; i < val; i += 1) {
            newDetails.push(Object.assign({}, deepClone(this.tbdDetailDefault)))
          }
          this.itemData.details = this.itemData.details.concat(newDetails)
        } else if (val < this.itemData.details.length) {
          // Get list of items we're removing
          const cancelled = this.itemData.details.slice(val, this.itemData.details.length).filter(d => !d.isPlaceholder && d.id)
          console.log('Cancelling', cancelled)
          this.itemData.cancelledDetails.push(...cancelled)
          this.itemData.details = this.itemData.details.slice(0, val)
          this.clearPathErrors(this.jsonPath, 'cancelledDetails')
          this.clearPathErrors(this.jsonPath, 'details')
          this.showCancelledReservees = true // Show cancelled reservees after you cancel them
        }
      }
    },
    tbdDetailDefault () {
      const result = deepClone(detailDefault)
      if (this.selectedEvent && this.selectedEvent.costs && this.selectedEvent.costs.length === 1) {
        // If only one cost is selected default new details to the single cost
        result.eventCostId = this.selectedEvent.costs[0].id
      }
      result.guestTypeId = this.guestTbdId
      return result
    },
    lastOpenDetail () {
      if (!this.itemData.details) return null
      var result = 0
      this.itemData.details.forEach((d, i) => {
        if (d.name || d.memberId || d.guestId) result = i
      })
      return result
    },
    hasDiscreteDetailValues () {
      // Check if any of the values we've filled in have discrete details yet
      return !!this.itemData.details.find((d, i) => i > 0 &&
        (d.memberId !== null || d.guestTypeId !== null && !this.guestTypeMap[d.guestTypeId].isTbd)
      )
    },
    guestTbdId () {
      return (this.activeGuestTypes.find(guestType => guestType.isTbd) || {}).id || null
    },
    eventOrLocation () {
      return this.forEvent ? 'Event' : 'Location'
    },
    promptForTableNumber () {
      return this.selectedLocation && this.selectedLocation.requestTableNumber || this.forEvent && this.forceEventTableNumPrompt
    },
    forEvent () {
      return this.propEventId !== false || !!this.selectedEventId || !this.$ftCS.DINING_USES_RESERVATIONS
    },
    isSaveDisabled () {
      return this.disabledWithoutDate || !this.selectedSeatingTime || this.selectedDateIsTooOld
    },
    disabledWithoutDate () {
      return this.isFormDisabled || !this.itemData.date || this.forEvent && !this.itemData.eventId
    },
    minimumDiningDate () {
      return this.$ftAPI().clubMoment().subtract(this.forEvent ? this.$ftCS.DINING_PAST_EVENT_MODIFY_DAYS : this.$ftCS.DINING_PAST_RES_MODIFY_DAYS, 'days').format('YYYY-MM-DD')
    },
    maximumDiningDate () {
      return this.$ftAPI().clubMoment().add(this.$ftCS.DINING_MAX_DAYS_IN_ADV_STAFF, 'days').format('YYYY-MM-DD')
    },
    selectedDate () {
      return this.itemData.date
    },
    selectedEventId () {
      return this.itemData.eventId
    },
    selectedEventDateTime () {
      const pastError = (this.selectedEvent && this.selectedEvent.cancelled ? 'Event is Canceled' : '') || this.selectedDateIsInPastMessage
      return this.formatEventDateTime(this.selectedEvent) + (pastError ? ' (' + pastError + ')' : '')
    },
    reservationTypes () {
      const result = []
      if (this.$ftCS.DINING_USES_RESERVATIONS) {
        result.push(
          {
            name: 'Dining',
            code: 'DINING',
            onEntry: () => {},
            onSelect: () => {
              this.forceEvent = false
              this.itemData.eventId = null
              this.forceMealPeriod = true
              // Update seating times
              this.seatingTimes = []
              this.locations = []
              localStorage.setItem('lastReservationType', 'DINING')
              this.loadSeatingTimes()
            },
            isSelected: () => {
              const sType = this.reservationType || {}
              return !this.forEvent &&
                (this.reservationType === null && this.isWalkin === undefined || sType.code === 'DINING')
            }
          }
        )
      }
      if (this.$ftCS.DINING_USES_RESERVATIONS &&
        this.$ftCS.DINING_USES_WALKINS) {
        result.push(
          {
            name: 'Walk-In',
            code: 'WALK_IN',
            onEntry: () => {},
            onSelect: () => {
              this.forceEvent = false
              this.itemData.eventId = null
              this.forceMealPeriod = true
              // Update seating times
              this.seatingTimes = []
              this.locations = []
              localStorage.setItem('lastReservationType', 'WALK_IN')
              this.walkInDateSelect()
              // this.walkInTimeSelect() // this is done in seatingTimes watcher, not here
              this.loadSeatingTimes()
            },
            isSelected: () => {
              const sType = this.reservationType || {}
              return !this.forEvent &&
              (this.reservationType === null && this.isWalkin !== undefined || sType.code === 'WALK_IN')
            }
          }
        )
      }
      if (this.$ftCS.DINING_USES_EVENTS) {
        result.push(
          {
            name: 'Event',
            code: 'EVENT',
            onEntry: () => {},
            onSelect: () => {
              this.forceEvent = true
              this.forceMealPeriod = false
              this.itemData.mealPeriodId = null
              // Update seating times
              this.seatingTimes = []
              this.locations = []
              localStorage.setItem('lastReservationType', 'EVENT')
              this.loadSeatingTimes()
            },
            isSelected: () => {
              return this.forEvent
            }
          }
        )
      }
      return result
    },
    selectedEvent () {
      return this.eventMap[this.selectedEventId]
    },
    selectedReservationType () {
      const result = this.reservationTypes.find(t => t.isSelected(this.forEvent, this.isWalkin)) || {}
      console.log('SELECTED RESERVATION TYPE', result, this.isWalkin, this.forEvent)
      return result
    },
    selectedReservationTypeIndex: {
      get () {
        return this.reservationTypes.indexOf(this.selectedReservationType)
      },
      set (val) {
        const type = this.reservationTypes[val]
        if (type && type !== this.selectedReservationType) {
          this.reservationType = type
          type.onSelect()
        }
      }
    },
    propEventId () {
      // get event id sent in props
      if (this.forceMealPeriod) return false
      return this.eventId !== undefined || this.forceEvent ? this.eventId || null : false
    },
    isPlaceholderReservation () {
      console.log('Is PlaceHolder:', this.itemData.isPlaceHolder, this.itemData)
      return this.itemData.isPlaceHolder || false
    },
    showCreateWaitlist () {
      console.log('Is showCreateWaitlist:', this.itemData.isPlaceHolder, this.itemData)
      return this.itemData.isPlaceHolder || false
    },
    showConvertWaitListToReservation () {
      return !this.itemData.isPlaceHolder && this.itemData.waitlist
    },
    showConvertReservationToWaitList () {
      return !this.itemData.isPlaceHolder && !this.itemData.waitlist
    },
    reservationSaveText () {
      return this.showCreateWaitlist ? 'New Reservation' : false // defaults to 'Save' if false/undefined
    },
    selectedLocationId () {
      // get event id selected for this reservation
      console.log('Selected Location', this.itemData.locationId)
      return this.itemData.locationId
    },
    eventList () {
      const clubMoment = this.$ftAPI().clubMoment()
      const clubDate = clubMoment.format('YYYY-MM-DD')
      const editDays = this.$ftCS.DINING_PAST_EVENT_MODIFY_DAYS
      const disableDate = this.isNewItem ? clubMoment.subtract(editDays, 'days').format('YYYY-MM-DD') : false
      console.log('Disabling events before', disableDate)
      const currentEvents = this.events.filter(e => e.date >= clubDate && !e.cancelled)
      const pastEvents = this.events.filter(e => (!disableDate || e.date >= disableDate) && e.date < clubDate && !e.cancelled)
      const cancelledEvents = this.events.filter(e => !this.isNewItem && (!disableDate || e.date >= disableDate) && e.cancelled)
      return [
        ...currentEvents.length ? [{header: 'Current'}] : [],
        ...currentEvents,
        ...pastEvents.length ? [{divider: true}, {header: 'Past'}] : [],
        ...pastEvents,
        ...cancelledEvents.length ? [{divider: true}, {header: 'Canceled'}] : [],
        ...cancelledEvents
      ]
    },
    eventByDateMap () {
      return this.events.reduce((o, e) => {
        const bStart = moment(e.startDateTime).format('YYYY-MM-DD')
        const bEnd = moment(e.endDateTime).format('YYYY-MM-DD')
        var ary = o[bStart]
        if (!ary) {
          ary = []
          o[bStart] = ary
        }
        ary.push(e)
        if (bStart !== bEnd) {
          ary = o[bEnd]
          if (!ary) {
            ary = []
            o[bEnd] = ary
          }
          ary.push(e)
        }
        return o
      }, {})
    },
    blockerByDateMap () {
      return this.blockers.reduce((o, b) => {
        const bStart = moment(b.startDate)
        const bEnd = moment(b.endDate)
        for (var m = bStart; m.isSameOrBefore(bEnd); m.add(1, 'days')) {
          let d = m.format('YYYY-MM-DD')
          var ary = o[d]
          if (!ary) {
            ary = []
            o[d] = ary
          }
          ary.push(b)
        }
        return o
      }, {})
    },
    selectedLocation () {
      return this.locations.find(location => location.id === this.selectedLocationId)
    },
    firstValidSeatingTime () {
      return this.seatingTimes.find(t => !t.disabled && !t.invalid && !t.blockReason)
    },
    validSeatingTimes () {
      return this.seatingTimes.filter(t => !t.disabled && !t.invalid && !t.blockReason)
    },
    seatingTimesList () {
      if (this.selectedLocationId) {
        // If event res, filter times by selected location, if one is selected
        return this.seatingTimes.filter(t => t.locationId === this.selectedLocationId || !this.availLocationsMap[this.selectedLocationId])
      } else {
        return this.seatingTimes
      }
    },
    availSeatingTimes () {
      return this.seatingTimes.filter(t => !t.invalid && !t.disabled && !t.blockReason)
    },
    usedTableQuantity () {
      return (this.itemData.tableAssignments || []).reduce((a, t) => t.quantity + a, 0)
    },
    selectedSeatingTime: {
      get () {
        if (!this.forEvent) {
          // Meal period
          return this.seatingTimes.find(seatingTime => seatingTime.time === this.itemData.time &&
            this.getMealPeriod(seatingTime.mealPeriodId).locationId === this.itemData.locationId) || null
        } else {
          // Event
          return this.seatingTimes.find(seatingTime => seatingTime.time === this.itemData.time &&
            seatingTime.locationId === this.itemData.locationId) || null
        }
      },
      set (val) {
        this.setSelectedSeatingTime(val)
      }
    },
    blockedGuestTypes () {
      const selectedSeating = this.selectedSeatingTime
      if (selectedSeating) {
        return selectedSeating.blockedGuestTypeIds.reduce((a, id) => {a[id] = true; return a}, {})
      } else {
        return {}
      }
    },
    selectedMealPeriod () {
      return this.getMealPeriod((this.selectedSeatingTime || {}).mealPeriodId) || null
    },
    requireTableSelection () {
      const requireTableAssignment = this.forEvent ?
        (((this.selectedEvent || {}).locations || []).find(l => l.locationId === this.itemData.locationId) || {}).requireTableAssignment :
        (this.selectedMealPeriod || {}).requireTableAssignment
      return this.selectedTableConfiguration && requireTableAssignment
    },
    selectedTableConfiguration () {
      const targetId = this.forEvent ?
        (((this.selectedEvent || {}).locations || []).find(l => l.locationId === this.itemData.locationId) || {}).tableConfigId :
        (this.selectedMealPeriod || {}).tableConfigId
      return this.tableConfigurations.find(t => t.id === targetId)
    },
    selectedTableConfigurationTablesMap () {
      const result = ((this.selectedTableConfiguration || {}).tables || []).reduce((result, o) => {
        result[o.tableId] = o
        return result
      }, {})
      return result
    },
    noTimesMessage () {
      var message = 'No times found '
      if (!this.forEvent && this.selectedLocation) {
        // Meal period, and location is set
        message += 'for ' + this.selectedLocation.name + ' '
      }
      message += 'on ' + this.itemData.date
      return message
    },
    eventToLocationMap () {
      return this.eventToLocations.reduce((result, e2l) => {
        result[e2l.locationId] = e2l
        return result
      }, {})
    },
    minFilterDate () {
      const minDateDefault = this.minFilterDateTime ? moment(this.minFilterDateTime).format('YYYY-MM-DD') : null
      return this.selectedEventsFilter.reduce((min, event) => {
        return event.date < min || !min ? event.date : min
      }, minDateDefault)
    },
    maxFilterDate () {
      const maxDateDefault = this.maxFilterDateTime ? moment(this.maxFilterDateTime).format('YYYY-MM-DD') : null
      return this.selectedEventsFilter.reduce((max, event) => {
        return event.date > max || !max ? event.date : max
      }, maxDateDefault) || this.$ftAPI().clubMoment().add(5, 'years').format('YYYY-MM-DD')
    },
    distinctEventNames () {
      const names = {}
      return this.events.filter(e => {
        if (!names[e.name]) {
          names[e.name] = e
          return true
        }
        return false
      })
    },
    dressCodeMap () {
      return this.dressCodes.reduce((result, i) => {
        result[i.id] = i
        return result
      }, {})
    },
    musicalStyleMap () {
      return this.musicalStyles.reduce((result, i) => {
        result[i.id] = i
        return result
      }, {})
    },
    eventMap () {
      return this.events.reduce((result, event) => {
        result[event.id] = event
        return result
      }, {})
    },
    guestTypeMap () {
      return this.guestTypes.reduce((result, guestType) => {
        result[guestType.id] = guestType
        return result
      }, {})
    },
    usedGuestTypeMap () {
      return this.itemData.details.reduce((result, detail) => {
        if (detail.guestTypeId) {
          result[detail.guestTypeId] = true
        }
        return result
      }, {})
    },
    selectedDateIsTooOld () {
      if (this.itemData.date) {
        const selectedDate = moment(this.itemData.date + ' 23:59:59')
        return selectedDate.isBefore(this.minimumDiningDate)
      }
      return false
    },
    selectedDateIsInPast () {
      if (this.itemData.date) {
        const now = this.$ftAPI().clubMoment()
        const selectedDate = moment(this.itemData.date + ' 23:59:59')
        return selectedDate.isBefore(now)
      }
      return false
    },
    selectedDateIsInPastMessage () {
      if (!this.selectedDateIsInPast) return
      return this.forEvent ? 'Event is in the past' : 'Date is in the past'
    },
    availLocationsMap () {
      return this.availLocations.reduce((result, location) => {
        result[location.id] = location
        return result
      }, {})
    },
    availLocations () {
      const {locationId} = this.floorPlanWalkInData ?? {}
      const eventToLocationMap = this.eventToLocationMap
      if (this.forEvent) {
        // For event res
        return this.locations
          // Only return locations applicable to this event
          .filter(location => !!eventToLocationMap[location.id])
          // Sorted by the applicable location's binding order
          .sort((a, b) => {
            const ae2l = eventToLocationMap[a.id]
            const be2l = eventToLocationMap[b.id]
            return ae2l.pos < be2l.pos ? -1 : ae2l.pos > be2l.pos ? 1 : 0
          })
      } else if (locationId) {
        // For a new Walk-In reservation from Floor Plan
        this.itemData.locationId = locationId
        return this.locations.filter(location => location.id === locationId)
      } else { 
        // For meal period res
        // Float enabled locations to the top
        return this.locations.filter(location => !location.disabled).concat(
          this.locations.filter(location => location.disabled)
        )
      }
    },
    activeGuestTypes () {
      return this.guestTypes.filter(g => !g.useGuestdb && (!g.disabled || this.usedGuestTypeMap[g.id]))
    },
    modGuestTypes () {
      return [{id: null, name: 'Member', selectType: 'member'}].concat(this.activeGuestTypes.filter(g => !g.useGuestdb))
    },
    occasionsMap () {
      return this.occasions.reduce((result, item) => {
        result[item.id] = item
        return result
      }, {})
    },
    itemDetails () {
      return this.itemData.details
    },
    selectedMembers () {
      return this.itemData.details.reduce((s, m) => {
        if (m.memberId) s[m.memberId] = true
        return s
      }, {})
    },
    calledBackSwitch: {
      get () {
        if (!this.itemData.calledBackAt || !this.momentFormLoaded) return false
        return this.momentFormLoaded.isBefore(moment(this.itemData.calledBackAt))
      },
      set (val) {
        if (val) {
          if (this.originalCalledAt === false) {
            this.originalCalledAt = this.itemData.calledBackAt
          }
          this.itemData.calledBackAt = this.$ftAPI().clubMoment().format('YYYY-MM-DD HH:mm:ss')
        } else if (this.originalCalledAt !== false) {
          this.itemData.calledBackAt = this.originalCalledAt
        }
      }
    },
    forceEventTableNumPrompt () {
      return this.$ftCS.DINING_EVENT_FORCE_USE_TABLE_NUMBER
    },
    tableNumberUseOffset () {
      return this.$ftCS.DINING_WARN_TABLE_NUMBER_CLOSER_THAN
    },
    showReserveeMemNum () {
      return this.$ftCS.DINING_RESERVEE_SHOW_MEMNUM
    },
    showUsername () {
      return this.$ftAC.usernameInSelector
    }
  }
}
